import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_40 } from '../../../Button'
import { ICON_HEIGHT_24 } from '../../../Icon'
import { ButtonSelect, ButtonTextSelectControl } from '../../../Select'

import * as styles from './RequestProfileHeaderFooterMoreButton.module.css'

function RequestProfileHeaderFooterMoreButton({
  blocked,
  buttonClassName,
  className = styles.RequestProfileHeaderFooterMoreButton,
  options,
  qaName,
  onSelectItem,
}) {
  const { t } = useTranslation()

  return (
    <ButtonSelect
      Control={ButtonTextSelectControl}
      blocked={blocked}
      className={className}
      controlProps={{
        buttonProps: {
          Button: Button.Text,
          className: buttonClassName,
          height: BUTTON_HEIGHT_40,
          iconProps: { height: ICON_HEIGHT_24 },
          interactive: !blocked,
          isGrey: false,
          isInline: false,
          qaName,
          text: t('RequestProfile.HeaderFooterMoreButtonKey'),
        },
      }}
      dropdownFloatingConfig={{ maxWidthByRef: false }}
      dropdownProps={{
        className: styles.dropdown,
      }}
      listProps={{
        headerProps: {
          Search: null,
        },
        itemProps: {
          contentProps: {
            infoProps: {
              contentTextProps: {
                textProps: {
                  isSecondary: true,
                },
              },
            },
          },
        },
      }}
      options={options}
      onSelectItem={onSelectItem}
    />
  )
}

export default RequestProfileHeaderFooterMoreButton
